import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props){ super(props); this.state = { err: null }; }
  static getDerivedStateFromError(error){ return { err: error }; }
  componentDidCatch(error, info){ /* optional: send to logging */ }
  render(){
    if (this.state.err) {
      return (
        <div style={{padding:16,fontFamily:"system-ui"}}>
          <h3>Something went wrong</h3>
          <pre style={{whiteSpace:"pre-wrap"}}>{String(this.state.err?.message || this.state.err)}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}

